import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

/**
 * Phone-screen shell shared by every page: caps content to a phone-width
 * column (like a native iOS screen instead of a stretched web page),
 * centered in the browser window. The page scrolls normally at the
 * document level; the decorative home-indicator bar is just the last
 * thing in the column, respecting the device's safe area.
 */
export function AppScreen({ children }: Props) {
  return (
    <div className="min-h-dvh w-full flex justify-center bg-atlas-bg dark:bg-atlas-bg-dark">
      <div className="w-full max-w-[430px] flex flex-col">
        {children}
        <div
          className="shrink-0 flex items-center justify-center"
          style={{ height: `calc(26px + env(safe-area-inset-bottom))`, paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
          <div className="w-[134px] h-[5px] rounded-full bg-atlas-ink dark:bg-atlas-ink-dark opacity-25" />
        </div>
      </div>
    </div>
  );
}
